// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer-module--Footer--3zV-a","Footer__Link":"Footer-module--Footer__Link--BQMVl"};